import {
  type UseSuspenseQueryResult,
  useSuspenseQuery,
} from '@tanstack/react-query';

import api from '@/axios';
import { GET_SUPPLIERS_KEY } from '@/keys';
import type { Supplier } from '@/types/core/purchase-planning/supplier';

type GetSuppliersParams = {
  statusIds?: number[];
};

export const getSuppliers = async (
  params?: GetSuppliersParams,
): Promise<Supplier[]> => {
  const response = await api.get<Supplier[]>('/suppliers', {
    params,
  });
  return response.data;
};

export const useGetSuppliers = (
  params?: GetSuppliersParams,
): UseSuspenseQueryResult<Supplier[], Error> =>
  useSuspenseQuery({
    queryKey: [...GET_SUPPLIERS_KEY, params],
    queryFn: () => getSuppliers(params),
  });
